import productGroupFields from "./productGroupFields";
import footerCtaLinkFields from "./footerCtaLinkFields";
import { applyFrench } from "@lib/applyFrenchField";

const internalLink = `
    _type == "internalLink" => {
        "id": @.reference->_id,
        "type": @.reference->_type,
        "slug": @.reference->slug,
        "handle": @.reference->store.slug.current,
        "productGroup": *[_type == "product" && ^.reference->_id == _id] {
            "data": *[_type=='productPage' && references(^._id) ] {
                ${productGroupFields}
            }
        }[0],
    }
`;

const text = `${applyFrench(
  `text[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`,
  `text_fr.cbTextBlock[] {
        ...,
        markDefs[]{ ..., ${internalLink}}
    }`
)}`;

const contentBlocks = `
  contentSectionsRef[] {
    _type == "reference" => @-> {
        ...,
        contentSection {
            options {
                "backgroundOptions": { ...backgroundOptions },
                "spacingOptions": { ...spacingOptions },
                "footerOptions": {
                    ...footerOptions,
                    "caption": ${applyFrench("footerOptions.caption", "footerOptions.caption_fr")},
                    "ctaTitle": ${applyFrench(
                      "footerOptions.ctaTitle",
                      "footerOptions.ctaTitle_fr"
                    )},
                    "ctaLink": {
                        "refTitle": footerOptions.link.document->title,
                        "type": footerOptions.link.document->_type,
                        "link": footerOptions.link.link,
                        "handle": footerOptions.link.document->store.slug.current,
                        "slug": footerOptions.link.document->slug,
                        "productGroup": *[_type=="productPage" && references(^.footerOptions.link.document->_id) ] {
                            ${productGroupFields}
                        },
                    },
                },
                "sectionLink": {
                    "refTitle": link.document->title,
                    "type": link.document->_type,
                    "link": link.link,
                    "handle": link.document->store.slug.current,
                    "slug": link.document->slug,
                    "productGroup": *[_type=="productPage" && references(^.link.document->_id) ] {
                        ${productGroupFields}
                    },
                    "document": link.document
                },
            },
            contentBlocks[] {
                ...,
                _type == "contentBlockImage" => {
                    ...,
                    "altText": ${applyFrench("altText", "altText_fr")},
                    "footerOptions": {
                        "caption": ${applyFrench(
                          "footerOptions.caption",
                          "footerOptions.caption_fr"
                        )},
                        "showFooter": footerOptions.showFooter,
                        "footerOnTop": footerOptions.footerOnTop,
                        "textColor": footerOptions.textColor,
                        "ctaTitle": ${applyFrench(
                          "footerOptions.ctaTitle",
                          "footerOptions.ctaTitle_fr"
                        )},
                        "ctaLink": { ${footerCtaLinkFields} },
                    },
                },
                _type == "contentBlockVideo" => {
                    ...,
                    videoSrc {
                        ...,
                        asset->{
                            ...,
                            "url": "https://stream.mux.com/" + playbackId
                        }
                    },
                    "footerOptions": {
                        "caption": ${applyFrench(
                          "footerOptions.caption",
                          "footerOptions.caption_fr"
                        )},
                        "showFooter": footerOptions.showFooter,
                        "textColor": footerOptions.textColor,
                        "ctaTitle": ${applyFrench(
                          "footerOptions.ctaTitle",
                          "footerOptions.ctaTitle_fr"
                        )},
                        "ctaLink": { ${footerCtaLinkFields} },
                    },
                },
                "text": ${text}
            },
        },
    }
  }
`;

export default contentBlocks;